import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

type LatLng = {
  lat: number;
  lng: number;
}

export const formatDate = (date: Date | string | undefined, includeTime = false) => {
  // @ts-ignore
  const _date = date?.toLocaleDateString ? date as Date : new Date(date as string)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  if (includeTime) {
    options.hour = 'numeric';
    options.minute = 'numeric';
  }

  return _date.toLocaleDateString('en-US', options);
}

export const formatDateDayjs = (date: string, format: string) => {
  return dayjs.utc(date).format(format);
}


export const haversineDistance = (point1: LatLng, point2: LatLng): number => {
  const {lat: lat1, lng: lon1} = point1;
  const {lat: lat2, lng: lon2} = point2;
  const toRadians = (degree: number) => (degree * Math.PI) / 180;
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};
